import { render, staticRenderFns } from "./ImageWithDetailNew.vue?vue&type=template&id=2ca919ea&scoped=true&"
import script from "./ImageWithDetailNew.vue?vue&type=script&lang=js&"
export * from "./ImageWithDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithDetailNew.vue?vue&type=style&index=0&id=2ca919ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca919ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
